
export type Animal = {
	date: Date;
	herd: string;
	tagNumber: number;
	tailCondition: string;
	activeInjury: boolean;
	highSevereCount: number;
	highMildCount: number;
	midSevereCount: number;
	midMildCount: number;
	lowSevereCount: number;
	lowMildCount: number;
	dockedPosition: string;
}

export type Session = {
	session_id: number;
	current: Animal;
	previous: Animal;
	herd: string;
	date: Date;
	animals: Animal[];
	uploaded?: Date | null;
	closed?: Date | null;
}

export const DateRevivier = (key:any, value:any) => {
  if (typeof value === "string" && !isNaN(Date.parse(value))) {
    return new Date(value);
  }
  return value;
}

